import { render, staticRenderFns } from "./Ecosystem.vue?vue&type=template&id=72510f84&scoped=true"
import script from "./Ecosystem.vue?vue&type=script&lang=js"
export * from "./Ecosystem.vue?vue&type=script&lang=js"
import style0 from "./Ecosystem.vue?vue&type=style&index=0&id=72510f84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72510f84",
  null
  
)

export default component.exports